/**
 * Scotland Yard rule constants.
 *
 * Every numeric value here is sourced from `docs/rules.md`. The doc is the
 * source of truth: if you change a value here, change it (or its citation) in
 * `docs/rules.md` as well.
 */

/** A game lasts up to this many Mr. X moves. */
export const TOTAL_ROUNDS = 24

/**
 * Rounds on which Mr. X must reveal his current station after his move.
 * Source: docs/rules.md "Mr. X reveals".
 */
export const REVEAL_ROUNDS: ReadonlySet<number> = new Set([3, 8, 13, 18, 24])

export const MIN_DETECTIVES = 2
export const MAX_DETECTIVES = 5
export const MIN_PLAYERS = 3
export const MAX_PLAYERS = 6

/**
 * The 18 starting-position cards. Mr. X draws first, then each detective,
 * without replacement.
 * Source: docs/rules.md "Starting positions".
 */
export const START_POSITIONS: readonly number[] = [
  13, 26, 29, 34, 50, 53, 91, 94, 103, 112, 117, 132, 138, 141, 155, 174, 197, 198,
] as const

/**
 * Tickets dealt to each detective.
 *
 * NOTE: 11/8/4 is the modern Ravensburger 2013 quote. Older Milton Bradley
 * editions used 10/8/4. To switch, change `taxi` to 10 here.
 */
export const DETECTIVE_TICKETS = {
  taxi: 11,
  bus: 8,
  underground: 4,
} as const

/**
 * Mr. X's starting tickets.
 * Source: docs/rules.md "Mr. X receives".
 */
export const MRX_TICKETS = {
  taxi: 4,
  bus: 3,
  underground: 3,
  black: 5,
  doubleMove: 2,
} as const

/**
 * The three Thames ferry edges. Stored as ordered tuples for reference; the
 * engine treats edges as undirected.
 * Source: docs/rules.md "Black ticket".
 */
export const FERRY_PAIRS: readonly (readonly [number, number])[] = [
  [108, 115],
  [115, 157],
  [157, 194],
] as const
